import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JpqlComponent } from '../jpql.component';

@Component({
  selector: 'app-jpql-bulk-queries',
  templateUrl: './jpql-bulk-queries.component.html',
  styleUrl: './jpql-bulk-queries.component.scss'
})
export class JpqlBulkQueriesComponent {

  queryStr = '';
   
  constructor(public dialogRef: MatDialogRef<JpqlComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { }
  ) { }
  

  closeModal() {
    this.dialogRef.close();
  }
  
}
